import { Box, BoxProps, ColorOptions, Icon, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import React, { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import MerchantOnboarding from '../../screens/MerchantOnboarding'

const SearchMerchant = () => {
  const [mid, setMid] = useState('100002000061212')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [showButtons, setShowButtons] = useState(false)
  const [cancel, setCancel] = useState(false)
  const [onBoardingVisible, setOnBoardingVisible] = useState(false)
  const [isOnboarding, setOnboardingFlow] = useState(true)
  const [isVerifyMidFailure, setVerifyMidFailure] = useState(false)

  const { searchMerchantWithMid } = useStores((store) => ({
    searchMerchantWithMid: store.onboarding.searchMerchantWithMid,
  }))

  const [searchMerchantWithMidApi, { state, data }] = useLazyApiData(searchMerchantWithMid)
  const regex = /^\d{15}$/
  const isValidMid = mid.length === 15 && regex.test(mid)

  useEffect(() => {
    if (state === 'rejected' || data?.status === 'FAILURE') {
      if (!cancel) {
        setLoading(false)
        setError('The MID is invalid or not onboarded in MAS, We cannot onboard this merchant for now.')
        setShowButtons(true)
        setOnboardingFlow(false)
        setVerifyMidFailure(true)
      }
    } else if (state === 'fulfilled' && data?.status === 'SUCCESS') {
      if (data?.isPresentInMms === 'N') {
        //Onboard flow
        setError('We couldn’t find any merchant with this MID, Would you like to onboard this merchant?')
        setLoading(false)
        setShowButtons(true)
        setVerifyMidFailure(false)
      } else if (data?.isPresentInMms === 'Y') {
        //Already existing mid flow
        setOnboardingFlow(false)
        setShowButtons(true)
        setLoading(false)
        setOnBoardingVisible(true)
        setVerifyMidFailure(false)
      }
    }
  }, [cancel, data, state])

  const onSearchPress = () => {
    if (isValidMid) {
      if (isLoading) {
        setLoading(false)
        setCancel(true)
      } else {
        setCancel(false)
        setLoading(true)
        setError('')
        searchMerchantWithMidApi(mid)
      }
    } else {
      setError('Please neter valid MID')
    }
  }

  const handleNotNow = () => {
    setError('')
    setMid('')
    setShowButtons(false)
  }

  const handleOnPress = () => {
    if (!isVerifyMidFailure) {
      setOnBoardingVisible(true)
      setError('')
      setShowButtons(false)
    } else {
      setShowButtons(false)
      setVerifyMidFailure(false)
      setCancel(false)
      setError('')
      setMid('')
    }
  }

  const rightComp = () => {
    return (
      <Box w={100}>
        <ModBox show={isLoading} {...styles.loadingContainer}>
          <Loader type={'small'} color={'#A0A0A0' as ColorOptions} />
          <Spacer size={8} direction={'horizontal'} />
          <Text title={'Searching...'} color={'#A0A0A0' as ColorOptions} fontSize={12} fontFamily={'jiotype-medium'} />
        </ModBox>
      </Box>
    )
  }
  return (
    <Box {...styles.container}>
      <MerchantOnboarding
        visible={onBoardingVisible}
        setVisible={setOnBoardingVisible}
        mid={mid}
        isOnboarding={isOnboarding}
      />
      <Text title={'Merchant Onboarding'} fontSize={18} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
      <Box {...styles.innerContainer}>
        <Box {...styles.searchContainer}>
          <Text title={'Search for a merchant'} fontSize={14} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
          <Spacer direction="vertical" size={24} />
          <Box {...styles.textInputContainer(error)}>
            <TextInputNew
              placeholder="Search with an MID"
              paddingVertical={13}
              paddingHorizontal={16}
              value={mid}
              maxLength={15}
              onChangeText={setMid}
              focusBorderColor={'TRANSPARENT'}
              rightComponent={rightComp()}
            />
            <ModBox onPress={onSearchPress} {...styles.iconContainer(isValidMid)} show={!error}>
              <Icon id={isLoading ? 'CLOSE' : 'SEARCH'} color={'WHITE'} size={20} />
            </ModBox>
          </Box>
          <ModBox show={!!error} maxWidth={240}>
            <Spacer size={16} direction={'vertical'} />
            <Text fontSize={12} color={'ERROR'} fontFamily={'jiotype-medium'}>
              {error}
            </Text>
          </ModBox>
          <Spacer size={24} direction={'vertical'} />
          <ModBox flexDirection={'row'} gap={16} show={showButtons}>
            <ButtonNew
              height={40}
              width={174}
              type={'primarySmall'}
              title={isVerifyMidFailure ? 'Okay, Got it' : 'Onboard Merchant'}
              borderRadius={4}
              color={'BLUE_SHADE_PRIMARY'}
              onPress={handleOnPress}
            />
            <ModBox show={!isVerifyMidFailure}>
              <ButtonNew
                height={40}
                width={100}
                title={'Not now'}
                onPress={handleNotNow}
                borderRadius={4}
                borderWidth={1}
                borderColor={'BLUE_SHADE_PRIMARY'}
                color={'WHITE'}
                titleColor={'BLUE_SHADE_PRIMARY'}
                type={'secondarySmall'}
              />
            </ModBox>
          </ModBox>
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    f: 1,
    bg: 'WHITE',
    p: 24,
  } as BoxProps,
  innerContainer: {
    f: 1,
    justify: 'center',
    align: 'center',
  } as BoxProps,
  searchContainer: {
    borderWidth: 1,
    p: 48,
    borderRadius: 4,
    borderColor: '#0070B61F' as ColorOptions,
    bg: '#0070B60A' as ColorOptions,
  } as BoxProps,
  textInputContainer: (error: boolean) =>
    ({
      flexDirection: 'row',
      borderColor: error ? 'ERROR' : 'BLUE_SHADE_PRIMARY',
      borderRadius: 4,
      borderWidth: 1,
      bg: 'WHITE',
    } as BoxProps),
  loadingContainer: { f: 1, flexDirection: 'row', justify: 'center', align: 'center', ph: 4 } as BoxProps,
  iconContainer: (isValidMid: boolean) =>
    ({
      bg: 'BLUE_SHADE_PRIMARY',
      h: 48,
      w: 48,
      underlayColor: 'TRANSPARENT',
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      justify: 'center',
      disabled: !isValidMid,
      align: 'center',
    } as BoxProps),
}

export default SearchMerchant
